import { render, staticRenderFns } from "./userFaceLogs.vue?vue&type=template&id=4b3413c8"
import script from "./userFaceLogs.vue?vue&type=script&lang=js"
export * from "./userFaceLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports